import {
  Button,
  Dialog,
  Paper,
  Grid,
  IconButton,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  LinearProgress,
  Snackbar,
  Alert,
  Slide,
  DialogTitle,
  DialogActions,
  useMediaQuery,
  tableCellClasses,
  FormControlLabel,
  Checkbox,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Chip,
  Autocomplete,
  Switch,
  Divider,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Container } from 'reactstrap';

import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import UIContext from '../../context/UIContext';
import axios from '../../utils/axios';

const StyledTableCell = styled(TableCell)({
  color: 'white !important',
  border: 'solid 1px #dee2e6',
  fontWeight: '800',
  textAlign: 'center',
  backgroundColor: '#47A992',
  padding: 'none',
  whiteSpace: 'nowrap',
});

const FactoryProcessUnitInitialValue = {
  ProcessUnit: '',
  Factory: '',
  Address1: '',
  Address2: '',
  Address3: '',
  City: '',
  Zipcode: '',
  State: '',
  Country: '',
  ContactPerson: '',
  ContactNo: '',
  Active: 'Y',
};

const filterInitialValue = {
  searchTerm: '',
  Active: true,
};

const FactoryProcessUnit = () => {
  const [filterData, setFilterData] = useState(filterInitialValue);
  const [factoryProcessUnitTableData, setFactoryProcessUnitTableData] = useState([]);
  const [factoryProcessUnits, setFactoryProcessUnits] = useState([]);
  const [factory, setFactory] = useState([]);
  const [country, setCountry] = useState([]);
  const [UserId, setUserId] = useState(null);

  const [initialValue, setInitialValue] = useState(FactoryProcessUnitInitialValue);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);

  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);

  // api fetch data
  useEffect(() => {
    const UserId = sessionStorage.getItem('UserId');
    setUserId(UserId);
    getAllFactoryProcessUnit();
    GetAllHelpData();
  }, []);

  const GetAllHelpData = async () => {
    try {
      showLoading();
      const resData = await axios.get('/ReferenceData/GetAllFactories');
      const resData1 = await axios.get('/ReferenceData/GetAllCountry');
      setFactory(resData.data);
      setCountry(resData1.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  };

  const factoryProcessUnitValidationSchema = useMemo(
    () =>
      Yup.object().shape({
        ProcessUnit: Yup.string()
          .min(3, ({ min }) => `Minimum ${min} characters required`)
          .max(100, ({ max }) => `Cannot exceed more than ${max} characters`)
          .required('Enter Process Unit')
          .test('unique-pair', 'Process Unit & Factory combination already exists', (value, { parent }) => {
            const { Factory, ProcessUnit } = parent;
            console.log(Factory, ProcessUnit);
            return !factoryProcessUnits
              .filter((record) => Number(record.FactoryProcessId) !== Number(initialValue.FactoryProcessId))
              .some(
                (record) =>
                  Number(record.FactoryId) === Number(Factory?.AccId) &&
                  record.ProcessUnit?.toLowerCase()?.trim() === ProcessUnit?.toLowerCase()?.trim()
              );
          }),
        Factory: Yup.object().required('Please select Factory'),
        Address1: Yup.string()
          .min(3, ({ min }) => `Minimum ${min} characters required`)
          .max(100, ({ max }) => `Cannot exceed more than ${max} characters`)
          .required('Enter Address'),
        Address2: Yup.string()
          .min(3, ({ min }) => `Minimum ${min} characters required`)
          .max(100, ({ max }) => `Cannot exceed more than ${max} characters`),
        Address3: Yup.string()
          .min(3, ({ min }) => `Minimum ${min} characters required`)
          .max(100, ({ max }) => `Cannot exceed more than ${max} characters`),
        City: Yup.string()
          .min(2, ({ min }) => `Minimum ${min} characters required`)
          .max(50, ({ max }) => `Cannot exceed more than ${max} characters`),
        Zipcode: Yup.string()
          .min(3, ({ min }) => `Minimum ${min} characters required`)
          .max(10, ({ max }) => `Cannot exceed more than ${max} characters`)
          .matches(/^\d[\d\s-]{2,9}$/, 'Invalid Zipcode (only digits, single spaces, and hyphens allowed)'),
        State: Yup.string()
          .min(2, ({ min }) => `Minimum ${min} characters required`)
          .max(50, ({ max }) => `Cannot exceed more than ${max} characters`),
        ContactPerson: Yup.string()
          .min(3, ({ min }) => `Minimum ${min} characters required`)
          .max(50, ({ max }) => `Cannot exceed more than ${max} characters`)
          .required('Enter Contact Person'),
        ContactNo: Yup.string()
          .min(3, ({ min }) => `Minimum ${min} characters required`)
          .max(15, ({ max }) => `Cannot exceed more than ${max} characters`)
          .required('Enter Contact No'),
        Country: Yup.object().required('Please select Country'),
        Active: Yup.string().oneOf(['Y', 'N'], 'Please select Yes or No').required('Please select Yes or No'),
      }),
    [initialValue, factoryProcessUnits]
  );

  async function getAllFactoryProcessUnit() {
    try {
      showLoading();
      const response = await axios.get('Master/FactoryProcessUnit/GetAllFactoryProcessUnit');
      setFactoryProcessUnits(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function InsertFactoryProcessUnit(values) {
    try {
      const { Factory, Country, ...RemaingValues } = values;
      showLoading();
      const response = await axios.post('Master/FactoryProcessUnit/AddFactoryProcessUnit', {
        ...RemaingValues,
        Factory: Factory.AccId,
        Country: Country.CountryId,
        UserId,
      });
      getAllFactoryProcessUnit();
      openSnackBar('Factory Process Unit Added Successfully!');
      // setFilterData(filterInitialValue);
      setEdit(false);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
    setOpen(false);
  }

  const UpdateFactoryProcessUnit = async (values) => {
    try {
      const { Factory, Country, ...RemaingValues } = values;
      showLoading();
      await axios.post(`Master/FactoryProcessUnit/UpdateFactoryProcessUnit`, {
        ...RemaingValues,
        Factory: Factory.AccId,
        Country: Country.CountryId,
        UserId,
      });
      getAllFactoryProcessUnit();
      setInitialValue(FactoryProcessUnitInitialValue);
      openSnackBar('Factory Process Unit Updated Successfully!', 'warning');
      // setFilterData(filterInitialValue);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    setOpen(false);
    setEdit(false);
    hideLoading();
  };

  const DeleteFactoryProcessUnit = async () => {
    try {
      showLoading();
      await axios.delete(`Master/FactoryProcessUnit/DeleteFactoryProcessUnit/${deleteId}`);
      const newFactoryProcessUnit = factoryProcessUnits.filter(
        (factoryProcessUnit) => factoryProcessUnit.FactoryProcessId !== deleteId
      );
      setFactoryProcessUnits(newFactoryProcessUnit);
      setFactoryProcessUnitTableData(newFactoryProcessUnit);
      openSnackBar('Factory Process Unit Deleted Successfully!', 'warning');
      // setFilterData(filterInitialValue);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    handleCloseDelete();
    setDeleteId(null);
    hideLoading();
  };

  const handleEditClick = (values) => {
    const { FactoryId, FactoryName, CountryId, Country, ...RemaingValues } = values;
    const NewValues = {
      Factory: { AccId: FactoryId, AccName: FactoryName },
      Country: { CountryId, Country },
      ...RemaingValues,
    };
    setInitialValue(NewValues);
  };

  const handleFilterDataChange = (name, value) => {
    setFilterData({ ...filterData, [name]: value });
  };
  useEffect(() => {
    const newTableData = factoryProcessUnits.filter(
      (factoryProcessUnit) =>
        `${factoryProcessUnit.ProcessUnit} ${factoryProcessUnit.FactoryName} ${factoryProcessUnit.Address1} ${factoryProcessUnit.City} ${factoryProcessUnit.State} ${factoryProcessUnit.Country} ${factoryProcessUnit.Zipcode} ${factoryProcessUnit.ContactPerson} ${factoryProcessUnit.ContactNo} `
          .toLowerCase()
          .includes(filterData?.searchTerm?.toLowerCase()) &&
        factoryProcessUnit.Active?.toLowerCase()?.trim() === (filterData.Active ? 'y' : 'n')
    );
    if (page > 0) setPage(0);
    setFactoryProcessUnitTableData(newTableData);
  }, [factoryProcessUnits, filterData]);

  // function handleFactoryProcessUnitFilterSearch(filtertext) {
  //   setFactoryProcessUnitFilterSearch(filtertext);
  //   const newDivsionTableData = factoryProcessUnits.filter((factoryProcessUnit) =>
  //     `${factoryProcessUnit.ProcessUnit} ${factoryProcessUnit.FactoryName} ${factoryProcessUnit.Address1} ${factoryProcessUnit.City} ${factoryProcessUnit.State} ${factoryProcessUnit.Country} ${factoryProcessUnit.Zipcode} ${factoryProcessUnit.ContactPerson} ${factoryProcessUnit.ContactNo} `
  //       .toLowerCase()
  //       .includes(filtertext.toLowerCase())
  //   );
  //   if (page > 0) setPage(0);
  //   setFactoryProcessUnitTableData(newDivsionTableData);
  // }
  const handleCloseDelete = () => {
    setOpenDelete(false);
    setDeleteId(null);
  };

  const handleCloseDialog = () => {
    setOpen(!open);
    setEdit(false);
    setInitialValue(FactoryProcessUnitInitialValue);
  };

  // pagination
  const { emptyRows, totalRows, currentPage } = useMemo(() => {
    const totalRows = factoryProcessUnitTableData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

    return { emptyRows, totalRows, currentPage };
  }, [factoryProcessUnitTableData, page, rowsPerPage]);

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        {/* table header */}
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              // borderRadius: 50,
              background: '#47A992',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              FACTORY PROCESS UNIT MASTER
            </Typography>
          </Typography>
        </Grid>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent={'space-between'}
          alignItems={'center'}
          spacing={2}
          my={3}
          px={3}
        >
          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label="Search"
            size="small"
            onChange={(e) => {
              handleFilterDataChange('searchTerm', e.target.value);
            }}
            value={filterData.searchTerm}
          />
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="subtitle2" fontWeight="bold">
              Active
            </Typography>

            {/* Toggle Switch with "Yes" / "No" */}
            <FormControlLabel
              control={
                <Switch
                  checked={filterData.Active}
                  onChange={(e) => {
                    handleFilterDataChange('Active', !filterData.Active);
                  }}
                  color="success"
                />
              }
              label={filterData.Active ? 'Yes' : 'No'}
            />
            <Divider orientation="vertical" flexItem />
            <Button
              variant="outlined"
              color="secondary"
              sx={{ boxShadow: 1 }}
              onClick={() => setOpen(!open)}
              startIcon={<PlaylistAddIcon />}
            >
              Add Factory Process Unit
            </Button>
          </Stack>
        </Stack>
        <TableContainer sx={{ borderRadius: '7px', maxHeight: '450px' }} component={Paper} elevation={2}>
          <Table className="table-bordered" size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell align="center">S.No</StyledTableCell>
                <StyledTableCell align="left">Process Unit</StyledTableCell>
                <StyledTableCell align="left">Factory</StyledTableCell>
                <StyledTableCell align="left">Address</StyledTableCell>
                <StyledTableCell align="center">City</StyledTableCell>
                <StyledTableCell align="center">State</StyledTableCell>
                <StyledTableCell align="center">Country</StyledTableCell>
                <StyledTableCell align="center">Zipcode</StyledTableCell>
                <StyledTableCell align="center">Contact Person</StyledTableCell>
                <StyledTableCell align="center">Contact No</StyledTableCell>
                <StyledTableCell align="center">Active</StyledTableCell>
                <StyledTableCell align="center">Actions</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {(rowsPerPage > 0
                ? factoryProcessUnitTableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : factoryProcessUnitTableData
              ).map((factoryProcessUnit, i) => (
                <TableRow key={factoryProcessUnit.FactoryProcessId} hover>                  
                  <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                  {/* <TableCell align="center">{factoryProcessUnit.SNo}</TableCell> */}
                  <TableCell align="left">{factoryProcessUnit.ProcessUnit}</TableCell>
                  <TableCell align="left">{factoryProcessUnit.FactoryName}</TableCell>
                  <TableCell align="left">{factoryProcessUnit.Address1}</TableCell>
                  <TableCell align="left">{factoryProcessUnit.City}</TableCell>
                  <TableCell align="left">{factoryProcessUnit.State}</TableCell>
                  <TableCell align="left">{factoryProcessUnit.Country}</TableCell>
                  <TableCell align="left">{factoryProcessUnit.Zipcode}</TableCell>
                  <TableCell align="left">{factoryProcessUnit.ContactPerson}</TableCell>
                  <TableCell align="left">{factoryProcessUnit.ContactNo}</TableCell>
                  <TableCell align="center">
                    <Chip
                      color={factoryProcessUnit.Active === 'Y' ? 'success' : 'error'}
                      label={factoryProcessUnit.Active === 'Y' ? 'Yes' : 'No'}
                      size="small"
                      icon={factoryProcessUnit.Active === 'Y' ? <CheckCircleOutlineIcon /> : <HighlightOffIcon />}
                    />
                  </TableCell>

                  <TableCell align="center" sx={{ padding: '0' }}>
                    <IconButton
                      aria-label="Edit"
                      onClick={() => {
                        setEdit(true);
                        setOpen(true);
                        handleEditClick(factoryProcessUnit);
                      }}
                    >
                      <EditIcon color="primary" />
                    </IconButton>
                    <IconButton
                      aria-label="Delete"
                      onClick={() => {
                        setDeleteId(factoryProcessUnit.FactoryProcessId);
                        setOpenDelete(true);
                      }}
                    >
                      <DeleteForeverIcon color="error" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={11} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={currentPage} // Use the calculated currentPage value
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0); // Reset the page when rowsPerPage changes
          }}
          mt={2}
        />
        <Grid m={2}>
          {/* add new popup form dialog box */}
          <Dialog maxWidth={'md'} open={open} onClose={handleCloseDialog} fullWidth>
            <Container component={Paper} elevation={2} style={{ padding: '7px 14px' }}>
              <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mr={1}>
                <Typography variant="h6" textAlign={'left'} pl={2} fontWeight={600} color="primary">
                  {edit ? 'Edit' : 'Add'} Factory Process Unit
                </Typography>
                <IconButton onClick={handleCloseDialog}>
                  <CloseIcon />
                </IconButton>
              </Stack>
              <Stack sx={{ p: 1 }}>
                <Formik
                  validationSchema={factoryProcessUnitValidationSchema}
                  initialValues={initialValue}
                  onSubmit={async (values, { resetForm }) => {
                    if (edit) await UpdateFactoryProcessUnit(values);
                    else await InsertFactoryProcessUnit(values);
                    resetForm();
                  }}
                >
                  {({ submitForm, values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
                    <Form>
                      <Grid container spacing={2} p={1} rowSpacing={3}>
                        <Grid item xs={12} md={6}>
                          <TextField
                            required
                            fullWidth
                            size="small"
                            label="Process Unit"
                            type="text"
                            name="ProcessUnit"
                            onBlur={handleBlur}
                            error={!!errors.ProcessUnit && touched.ProcessUnit}
                            helperText={errors.ProcessUnit && touched.ProcessUnit ? errors.ProcessUnit : ''}
                            value={values.ProcessUnit}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Autocomplete
                            options={factory}
                            getOptionLabel={(factory) => factory.AccName}
                            isOptionEqualToValue={(value) => value.AccId === values.Factory.AccId}
                            renderOption={(props, factory) => (
                              <li {...props} key={factory.AccId}>
                                {factory.AccName}
                              </li>
                            )}
                            value={values.Factory || null}
                            name="Factory"
                            onChange={(event, value) => {
                              setFieldValue('Factory', value);
                            }}
                            size="small"
                            onBlur={handleBlur}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                label="Factory"
                                error={touched.Factory && !!errors.Factory}
                                helperText={touched.Factory && errors.Factory}
                              />
                            )}
                          />
                        </Grid>

                        <Grid item xs={12} md={4}>
                          <TextField
                            fullWidth
                            multiline
                            required
                            rows={3}
                            size="small"
                            label="Address 1"
                            type="text"
                            name="Address1"
                            onBlur={handleBlur}
                            error={!!errors.Address1 && touched.Address1}
                            helperText={errors.Address1 && touched.Address1 ? errors.Address1 : ''}
                            value={values.Address1}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            fullWidth
                            multiline
                            rows={3}
                            size="small"
                            label="Address 2"
                            type="text"
                            name="Address2"
                            onBlur={handleBlur}
                            error={!!errors.Address2 && touched.Address2}
                            helperText={errors.Address2 && touched.Address2 ? errors.Address2 : ''}
                            value={values.Address2}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            fullWidth
                            multiline
                            rows={3}
                            size="small"
                            label="Address 3"
                            type="text"
                            name="Address3"
                            onBlur={handleBlur}
                            error={!!errors.Address3 && touched.Address3}
                            helperText={errors.Address3 && touched.Address3 ? errors.Address3 : ''}
                            value={values.Address3}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            fullWidth
                            size="small"
                            label="City"
                            type="text"
                            name="City"
                            onBlur={handleBlur}
                            error={!!errors.City && touched.City}
                            helperText={errors.City && touched.City ? errors.City : ''}
                            value={values.City}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            fullWidth
                            size="small"
                            label="State / Province"
                            type="text"
                            name="State"
                            onBlur={handleBlur}
                            error={!!errors.State && touched.State}
                            helperText={errors.State && touched.State ? errors.State : ''}
                            value={values.State}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Autocomplete
                            options={country}
                            getOptionLabel={(country) => country.Country}
                            isOptionEqualToValue={(value) => value.CountryId === values.Country.CountryId}
                            renderOption={(props, country) => (
                              <li {...props} key={country.CountryId}>
                                {country.Country}
                              </li>
                            )}
                            value={values.Country || null}
                            name="Country"
                            onChange={(event, value) => {
                              setFieldValue('Country', value);
                            }}
                            size="small"
                            onBlur={handleBlur}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                label="Country"
                                error={touched.Country && !!errors.Country}
                                helperText={touched.Country && errors.Country}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Zipcode"
                            type="text"
                            name="Zipcode"
                            onBlur={handleBlur}
                            error={!!errors.Zipcode && touched.Zipcode}
                            helperText={errors.Zipcode && touched.Zipcode ? errors.Zipcode : ''}
                            value={values.Zipcode}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            required
                            fullWidth
                            size="small"
                            label="Contact Person"
                            type="text"
                            name="ContactPerson"
                            onBlur={handleBlur}
                            error={!!errors.ContactPerson && touched.ContactPerson}
                            helperText={errors.ContactPerson && touched.ContactPerson ? errors.ContactPerson : ''}
                            value={values.ContactPerson}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            required
                            fullWidth
                            size="small"
                            label="Contact No"
                            type="text"
                            name="ContactNo"
                            onBlur={handleBlur}
                            error={!!errors.ContactNo && touched.ContactNo}
                            helperText={errors.ContactNo && touched.ContactNo ? errors.ContactNo : ''}
                            value={values.ContactNo}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item width={'100%'}>
                          <FormControl size="small" fullWidth component="fieldset">
                            <FormLabel component="legend">Active Status</FormLabel>
                            <RadioGroup
                              row
                              value={values.Active?.trim()}
                              name="Active"
                              onBlur={handleBlur}
                              onChange={handleChange}
                            >
                              <FormControlLabel value="Y" control={<Radio size="small" />} label="Yes" />
                              <FormControlLabel value="N" control={<Radio size="small" />} label="No" />
                            </RadioGroup>
                            {errors.Active && touched.Active && (
                              <Typography
                                variant="caption"
                                color="error"
                                className={errors.Active ? 'shake-helper-text' : ''}
                              >
                                {errors.Active}
                              </Typography>
                            )}
                          </FormControl>
                        </Grid>
                      </Grid>

                      <Stack direction="row" justifyContent="center" gap={2} sx={{ textAlign: 'center', mt: 3 }}>
                        <Button
                          onClick={submitForm}
                          disabled={isSubmitting}
                          fullWidth
                          variant="contained"
                          color={edit ? 'warning' : 'primary'}
                          size="small"
                          sx={{ boxShadow: 1 }}
                        >
                          {edit ? 'Update' : 'Save'}
                        </Button>
                      </Stack>
                    </Form>
                  )}
                </Formik>
              </Stack>
            </Container>
          </Dialog>
        </Grid>
        {/* confirmation dialog */}
        <Dialog open={openDelete} onClose={handleCloseDelete} fullScreen={fullScreen} fullWidth maxWidth="xs">
          <DialogTitle id="responsive-dialog-title">Are you sure you want to delete?</DialogTitle>
          <DialogActions>
            <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
              Cancel
            </Button>
            <Button variant="contained" onClick={DeleteFactoryProcessUnit} color="error" autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
};

export default FactoryProcessUnit;
